import { z } from 'zod';

export const ProcessedBySchema = z.enum(['TRANSPORT_EXCHANGE', 'PARTNER']);
export type ProcessedBy = z.infer<typeof ProcessedBySchema>;
